import { render, staticRenderFns } from "./FugaExport.vue?vue&type=template&id=65c687a5&scoped=true&"
import script from "./FugaExport.vue?vue&type=script&lang=js&"
export * from "./FugaExport.vue?vue&type=script&lang=js&"
import style0 from "./FugaExport.vue?vue&type=style&index=0&id=65c687a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c687a5",
  null
  
)

export default component.exports